import { orderSchema } from "./schemas.mjs";
import { z } from "zod";
import { oc } from "@orpc/contract";
//#region src/api/orpc/order/index.ts
const orderContract = oc.prefix("/order").tag("Order").router({ getById: oc.route({
	method: "GET",
	path: "/{id}",
	summary: "Get order by ID"
}).input(z.object({ id: z.coerce.bigint() })).output(orderSchema).errors({
	UNAUTHORIZED: {
		status: 401,
		message: "User not authenticated"
	},
	ORDER_NOT_FOUND: {
		status: 404,
		message: "Order not found"
	}
}) });
//#endregion
export { orderContract };
